/**
 * Onboarding-u te ndërfaqja — pasqyrë e fjalorit të serverit.
 *
 * Burimi: `backend/services/onboarding.js`. Këtu mbahen vetëm etiketat dhe
 * ngjyrat; rregullat — kush mund të mbyllet, çfarë kërkon arsye — i zbaton
 * serveri, dhe faqja vetëm nuk ofron butona që do të refuzoheshin.
 */

export const CATEGORIES = [
  { code: 'hr',         label: 'HR' },
  { code: 'it',         label: 'IT' },
  { code: 'manager',    label: 'Menaxheri' },
  { code: 'training',   label: 'Trajnim' },
  { code: 'employee',   label: 'Punonjësi' },
  { code: 'facilities', label: 'Ambientet' },
  { code: 'other',      label: 'Tjetër' },
];

export const ASSIGN_ROLES = [
  { code: 'hr',         label: 'HR' },
  { code: 'it',         label: 'IT' },
  { code: 'manager',    label: 'Menaxheri' },
  { code: 'team_lead',  label: 'Udhëheqësi i ekipit' },
  { code: 'trainer',    label: 'Trajneri' },
  { code: 'employee',   label: 'Punonjësi' },
  { code: 'facilities', label: 'Ambientet' },
  { code: 'unassigned', label: 'Pa përgjegjës' },
];

export const INSTANCE_STATUSES = [
  { code: 'draft',       label: 'Draft',        color: 'default' },
  { code: 'planned',     label: 'I planifikuar', color: 'info' },
  { code: 'in_progress', label: 'Në zhvillim',  color: 'primary' },
  { code: 'blocked',     label: 'I bllokuar',   color: 'warning' },
  { code: 'completed',   label: 'I përfunduar', color: 'success' },
  { code: 'cancelled',   label: 'I anuluar',    color: 'default' },
];

export const TASK_STATUSES = [
  { code: 'pending',     label: 'Në pritje',    color: 'default' },
  { code: 'in_progress', label: 'Në punë',      color: 'info' },
  { code: 'blocked',     label: 'E bllokuar',   color: 'warning' },
  { code: 'completed',   label: 'E kryer',      color: 'success' },
  { code: 'skipped',     label: 'E kapërcyer',  color: 'default' },
  { code: 'cancelled',   label: 'E anuluar',    color: 'default' },
];

const pick = (list, code) => list.find((x) => x.code === code) || null;
export const categoryLabel = (c) => pick(CATEGORIES, c)?.label || c || 'Tjetër';
export const roleLabel = (c) => pick(ASSIGN_ROLES, c)?.label || c || '—';
export const instanceMeta = (c) => pick(INSTANCE_STATUSES, c) || { code: c, label: c || '—', color: 'default' };
export const taskMeta = (c) => pick(TASK_STATUSES, c) || { code: c, label: c || '—', color: 'default' };

/** Gjendjet ku një detyrë nuk pret më askënd. */
export const TASK_CLOSED = ['completed', 'skipped', 'cancelled'];

/**
 * Gatishmëria për ditën e parë, në fjalë.
 *
 * Kur nuk janë përcaktuar detyra kritike, përgjigjja nuk është «gati» — është
 * «nuk dihet çfarë duhet». Premtimi i të parës do të ishte gënjeshtër e qetë.
 */
export function dayOneText(d = {}) {
  if (!d.defined) return 'Pa detyra kritike të përcaktuara';
  return d.ready ? 'Gati për ditën e parë' : `${d.completed}/${d.total} detyra kritike`;
}
